import { render, staticRenderFns } from "./DonutDistributionCard.vue?vue&type=template&id=0f6d4541&scoped=true&"
import script from "./DonutDistributionCard.vue?vue&type=script&setup=true&lang=js&"
export * from "./DonutDistributionCard.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DonutDistributionCard.vue?vue&type=style&index=0&id=0f6d4541&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6d4541",
  null
  
)

export default component.exports